import type { LocalAiSettings } from "./storage/preferences";

type LocalAiEnv = { readonly VITE_ENABLE_LOCAL_AI?: string | boolean };

export function isLocalAiFeatureEnabled(env: LocalAiEnv = import.meta.env as LocalAiEnv): boolean {
  return env.VITE_ENABLE_LOCAL_AI === "1";
}

export function isLocalAiRuntimeEnabled(
  settings: Pick<LocalAiSettings, "enabled">,
  env: LocalAiEnv = import.meta.env as LocalAiEnv
): boolean {
  return isLocalAiFeatureEnabled(env) && settings.enabled;
}
